// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"246":"landing","757":"game"}[chunkId] + "." + __webpack_require__.h() + ".css";
};